import { React, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import Login from "./Pages/Login";
import DashBoardNew from "./Pages/Admin/DashBoardNew";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RegisterPage from "./Pages/RegisterPage";
import ForgotPasswordPage from "./Pages/ForgotPassword";
import OtpPage from "./Pages/Otp";
import "./i18";
import { Remove_User } from "./Redux/actions";
import NotfoundPage from "./Components/NotfoundPage";
import Tenants from "./Pages/Admin/Tenants";
import AllProperties from "./Pages/Admin/AllProperties";
import Occupancy from "./Pages/Admin/Occupancy";
import PropComplaints from "./Pages/Admin/PropComplaints";
import TenantsComplaints from "./Pages/Admin/TenantsComplaints";
import LatestComplaints from "./Pages/Admin/LatestComplaints";
import Transactions from "./Pages/Admin/Transactions";
import Consolidate from "./Pages/Admin/Consolidate";
import PartnerWiseCollection from "./Pages/Collections/PartnerWiseCollectionScreen";

import Prospects from "./Pages/Admin/Prospects";
import RoomOptions from "./Pages/Admin/RoomOptions";
import Floors from "./Pages/Admin/Floors";
import OccupiedRooms from "./Pages/Admin/OccupiedRooms";
import Beds from "./Pages/Admin/Beds";
import AddTenant from "./Pages/Admin/AddTenant";
import ExtraCharges from "./Pages/Admin/ExtraCharges";
import SystemConfig from "./Pages/Admin/SystemConfig";
import OwnerExtraCharges from "./Pages/Admin/OwnerAddExtraCharges";
import Staff from "./Pages/Admin/Staff";
import AdminStaff from "./Pages/Admin/AdminStaff";
import { Expenses } from "./Pages/Admin/Expenses";
import { Colleges } from "./Pages/Admin/Colleges";
import { ExpensesType } from "./Pages/Admin/ExpensesType";
import Notifications from "./Pages/Admin/Notifications";
import AddBankPage from "./Pages/Admin/AddBankPage";
import Dues from "./Pages/Admin/Dues";
import PropertyDues from "./Pages/Admin/PropertyDues";
import Flats from "./Pages/Admin/Flats";
import Ledger from "./Pages/Admin/Ledger";
import RegistrationPage from "./Pages/Eqaro/Register";
import LoginPage from "./Pages/Eqaro/Login";
import EqaroUserListing from "./Pages/Eqaro/EqaroUserListing";
import PropertyForm from "./Pages/Eqaro/PropertyForm";
import BedsDetails from "./Pages/Admin/BedsDetails";
import TenantDetails from "./Pages/Admin/TenantDetails";
import EqaroProperties from "./Pages/Eqaro/EqaroProperty";

import Settings from "./Pages/Admin/Settings";
import SampleCard from "./Components/NewComponents/SampleCard";
import Notice from "./Pages/Admin/Notice";
import LoginInternal from "./Pages/LoginInternal";
import RecentUsed from "./Pages/Admin/RecentUsed";
import LoginRightInternal from "./Pages/LoginRightInternal";
import ElectricityDetails from "./Components/Dues/ElectricityDetails";
import Asset from "./Pages/Assets/Assets";
import SystemLog from "./Pages/Admin/SystemLog";
import AllTransaction from "./Pages/Admin/AllTransaction";
import RichText from "./Pages/Admin/RichText";
import NewStaff from "./Pages/Admin/NewStaff";
import EqaroTenants from "./Pages/Eqaro/EqaroTenants";
import OwnerTransaction from "./Pages/Admin/OwnerTransaction";
import PropertiesTransaction from "./Pages/Admin/PropertiesTransaction";
import MoveOut from "./Pages/Admin/MoveOut";
import Otp from "./Pages/Admin/Otp";
import HoldAmount from "./Pages/Admin/HoldAmount";
import RecentStaff from "./Pages/Admin/RecentStaff";
import Leads from "./Pages/Admin/Leads";
import OwnerStaff from "./Pages/Admin/OwnerStaff";
import Setting from "./Pages/Admin/Setting";
import ClientConfig from "./Pages/Admin/ClientConfig";
import AddClientConfigPage from "./Pages/Admin/AddClientConfig";
import EditClientConfigPage from "./Pages/Admin/EditClientConfig";
import ActiveLogs from "./Pages/Admin/ActiveLogs";
import { DuesLogs } from "./Pages/Admin/DuesLogs";
import PartnerWiseTenants from "./Pages/Admin/PartnerWiseTenants";
import Users from "./Pages/Admin/Users";
import Inventories from "./Pages/Admin/AllInventories";
import Inventory from "./Pages/Admin/Inventories";

function App() {
  const user = useSelector((state) => state.UserReducer.user);
  const dispatch = useDispatch();
  const isSessionExpired = () => {
    if (user) {
      const expireAt = user?.expireAt;
      const currentTime = moment().valueOf();
      const isExpired = moment(currentTime).isAfter(expireAt);
      if (isExpired) {
        window.location.href = "/";
        dispatch(Remove_User());
      }
    }
  };
  useEffect(() => isSessionExpired(), []);
  if (!user)
    return (
      <>
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
        />
        <Routes>
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/get-otp" element={<OtpPage />} />
          <Route path="*" index element={<Login />} />
        </Routes>
      </>
    );
  return (
    <>
      {/* <div className="flex h-screen overflow-hidden"> */}
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />

      <Routes>
        <Route path="/settings" element={<Settings />} />
        <Route path="/login" element={<Login />} />
        <Route path="/otptest" element={<LoginRightInternal />} />
        <Route path="/login-internal" element={<LoginInternal />} />
        <Route path= "/recent-used" element={<RecentUsed />} />
        <Route path= "/consolidate" element={<Consolidate />} />
        <Route path= "/partner-wise" element={<PartnerWiseCollection />} />
        
        {/* <Route path="/add-asset" element={<AddAsset />} /> */}
        <Route path="/add-asset" element={<Asset />} />
        <Route path="/electrity" element={<ElectricityDetails />} />
        <Route path="/samplecard" element={<SampleCard />} />
        <Route path = "/notice" element={<Notice />} />
        <Route path="/tenantdetails/:id" element={<TenantDetails />} />
        <Route path="*" element={<NotfoundPage />} />
        <Route path="/" element={<Users />} />
        <Route path="/dashboard" element={<DashBoardNew />} />
        <Route path="/users" element={<Users />} />
        <Route path="/tenants" element={<Tenants />} />
        <Route path="/inventories/:id" element={<Inventory />} />
        <Route path="/occupancy/:id" element={<Occupancy />} />
        <Route path="/dues/:tenantId" element={<Dues />} />
        <Route path="/dues/:id/:clientId" element={<Dues />} />
        <Route path="/complaints/:id/:clientId" element={<PropComplaints />} />
        <Route path="/tenantscomplaints/:id" element={<TenantsComplaints />} />
        <Route path="/complaints" element={<LatestComplaints />} />
        <Route path="/transactions/:tenantId" element={<Transactions />} />
        {/* <Route path="/Room" element={<Room/>}/>  */}
        <Route path="prospects" element={<Prospects />} />
        <Route path="allproperties" element={<AllProperties />} />
        <Route path="/inventories" element={<Inventories />}/>
        <Route path="/ownerstaff/:id" element={<OwnerStaff />}/>
        <Route path="/setting/:id" element={<Setting />} />
        <Route path="/clientconfig/:id" element={<ClientConfig />}/>
        <Route path="/clientconfig/:id/addclientconfig" element={<AddClientConfigPage />}/>
        <Route path="/clientconfig/:id/editclientconfig/" element={<EditClientConfigPage />} />
        <Route path="/activelogs/:id" element={<ActiveLogs />} />
        <Route path="/dueslogs/" element={<DuesLogs />}/>
        <Route path="/partnerwisetenants" element={<PartnerWiseTenants />} />
        <Route path="roomoptions/:id" element={<RoomOptions />} />
        <Route path="floors/:id" element={<Floors />} />
        <Route path="flats/:id" element={<Flats />} />
        <Route path="beds/:roomId" element={<Beds />} />
        <Route
          path="occupiedroom/:propId/:roomId"
          element={<OccupiedRooms />}
        />
        <Route
          path="addtenant/:propId/:roomId/:clientId"
          element={<AddTenant />}
        />
        <Route
          path="extracharges/:clientId/:propId"
          element={<ExtraCharges />}
        />
        <Route path="beddetails/:id" element={<BedsDetails />} />
        <Route path="/systemconfig" element={<SystemConfig />} />
        <Route path = "/systemlog" element={<SystemLog />} />
        <Route path="/charges/:clientId" element={<OwnerExtraCharges />} />
        <Route path="/staff/:clientId" element={<Staff />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/allstaff" element={<AdminStaff />} />
        <Route path="/recent-staff" element={<RecentStaff />} />
        <Route path="/newstaff" element={<NewStaff />} />
        <Route path="/colleges" element={<Colleges />} />
        <Route path="/notifications/:id" element={<Notifications />} />
        <Route path="/propertydues/:id/:clientId" element={<PropertyDues />} />
        <Route path="/ledger/:id" element={<Ledger />} />
        <Route path="/expensestype" element={<ExpensesType />} />
        <Route path="/bank/:clientId" element={<AddBankPage />} />
        <Route path="/eqaroRegister" element={<RegistrationPage />} />
        <Route path="/eqaroLogin" element={<LoginPage />} />
        <Route path="/eqaro-users" element={<EqaroUserListing />} />
        <Route path="/eqaroPropertyForm/:clientId" element={<PropertyForm />} />
        <Route path="/alltransaction" element={<AllTransaction />} />
        <Route path="/owner/transactions/:id"element={<OwnerTransaction />}/>
        <Route path="/moveout"element={<MoveOut />}/>
        <Route path="/otp"element={<Otp />}/>
        <Route path="/holdtransaction"element={<HoldAmount />}/>
        <Route path="/properties/transactions/:clientId/:id"element={<PropertiesTransaction />}/>
        <Route path="/richtext/:clientId/:id" element={<RichText />} />
        <Route path="/leads" element={<Leads />} />
        <Route
          path="/eqaroproperties/:clientId/:landlordId"
          element={<EqaroProperties />}
        />
        <Route
          path="/eqarotenants/:clientId"
          element={<EqaroTenants />}
        />
        
      </Routes>
      {/* </div>
      </div> */}
    </>
  );
}

export default App;
